import { IRichText } from '@modeso/types__aumico-lib-notes-be';

export interface IRichTextDelegate {
    richTextContent(content: IRichText[], componentIndex: number): void;
}
